export enum UserRole {
    Admin = "admin",
    Operator = "operator",
    Premium = "premium",
    Plus = "plus",
    PlusLB = "plus_lb",
}
